// @flow

import React, { type Node, useState, useCallback } from 'react';

import { DepositInformation } from './deposit-information';
import { InformationAccordion } from './information-accordion';
import { InformationAccordionHeader } from './information-accordion-header';
import { TransferInformation } from './transfer-information';

export function ProviderInformation(): Node {
  const [selectedProviderType, setAsTransfer, setAsDeposit] = useSelectedProviderType();

  return (
    <InformationAccordion>
      <InformationAccordionHeader active={selectedProviderType === 'transfer'} onClick={setAsTransfer}>
        Transferencia
      </InformationAccordionHeader>

      {selectedProviderType === 'transfer' && <TransferInformation />}

      <InformationAccordionHeader
        active={selectedProviderType === 'deposit'}
        onClick={setAsDeposit}
      >
        Deposito
      </InformationAccordionHeader>

      {selectedProviderType === 'deposit' && <DepositInformation />}
    </InformationAccordion>
  );
}

function useSelectedProviderType(): [string, () => void, () => void] {
  const [selectedProviderType, setSelectedProviderType] = useState('transfer');

  const setAsTransfer = useCallback(() => setSelectedProviderType('transfer'), [setSelectedProviderType]);
  const setAsDeposit = useCallback(() => setSelectedProviderType('deposit'), [setSelectedProviderType]);

  return [selectedProviderType, setAsTransfer, setAsDeposit];
}
